<template>
  <div class="mytickets-container">

    <BannerSearch> </BannerSearch>
    <div class="myticket">

      <div class="innerbox">
        <div class="top-box">
          <div class="search">
            <img src="../assets/images/muticket_search.png" alt="" />
            <input v-model="search" type="text" :placeholder="$t('m.myticket.search')" />

          </div>
          <div class="check">
            <!-- <div class="list-show">Reply Recelved</div> -->
            <!-- <MyShowList :bgcolor="'#fffcf4'" :max="240" :arr="true" :li="li"></MyShowList> -->
            <el-select :popper-append-to-body="false" class="select" v-model="searchStatus" placeholder="请选择"
              ref="multiSelectZH" v-if="$i18n.locale == 'zh'" @click="hooseCustomZH()">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select :popper-append-to-body="false" class="select" v-model="searchStatus" placeholder="请选择" v-else
              ref="multiSelectEN" @click="hooseCustomEN()">
              <el-option v-for="item in optionsEn" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>




        <div class="container">
          <el-skeleton style="width: 100%;" :loading="loading" animated>
            <template slot="template">
              <el-skeleton-item variant="text" v-for="index in 40" style="width: 20%;margin:10px 2.5%;" :key="index" />
            </template>

            <template v-if="$i18n.locale == 'en'">
              <el-table class="big" :empty-text="'No available data'"
                :data="this.$store.state.udeskList.filter(data => !search || data.TextField_2078.toLowerCase().includes(search.toLowerCase()))"
                fit style="width: 100%;" @row-click="rowClick">
                <el-table-column v-for="(sub, index) in this.$store.state.udeskSub" :key="index" :prop="sub.ticket_fields"
                  :class-name="sub.ticket_fields" :label="sub.list_fields" align="center">
                  <template slot-scope="scope">
                    <span v-if="sub.ticket_fields == 'created_at'">{{ convertedTime(scope.row[sub.ticket_fields])
                    }}</span>
                    <span v-else :class="getCellClass(sub.ticket_fields, scope.row)">{{ scope.row[sub.ticket_fields]
                    }}</span>
                  </template>

                </el-table-column>
              </el-table>
              <el-table class="small" :empty-text="'No available data'"
                :data="this.$store.state.udeskList.filter(data => !search || data.TextField_2078.toLowerCase().includes(search.toLowerCase()))"
                fit style="width: 100%;" @row-click="rowClick">
                <el-table-column v-for="(sub, index) in subNoCreateTs" :key="index" :prop="sub.ticket_fields"
                  :class-name="sub.ticket_fields" :label="sub.list_fields" align="center">
                  <template slot-scope="scope">
                    <span v-if="sub.ticket_fields == 'created_at'">{{ convertedTime(scope.row[sub.ticket_fields])
                    }}</span>
                    <span v-else :class="getCellClass(sub.ticket_fields, scope.row)">{{ scope.row[sub.ticket_fields]
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template v-else>

              <el-table class="big"
                :data="this.$store.state.udeskList.filter(data => !search || data.TextField_1371.toLowerCase().includes(search.toLowerCase()))"
                fit style="width: 100%;" @row-click="rowClick">
                <el-table-column v-for="(sub, index) in this.$store.state.udeskSub" :key="index" :prop="sub.ticket_fields"
                  :class-name="sub.ticket_fields" :label="sub.list_fields" align="center">
                  <template slot-scope="scope">
                    <span v-if="sub.ticket_fields == 'created_at'">{{ convertedTime(scope.row[sub.ticket_fields])
                    }}</span>
                    <span v-else :class="getCellClass(sub.ticket_fields, scope.row)">{{ scope.row[sub.ticket_fields]
                    }}</span>
                  </template>

                </el-table-column>
              </el-table>
              <el-table class="small"
                :data="this.$store.state.udeskList.filter(data => !search || data.TextField_1371.toLowerCase().includes(search.toLowerCase()))"
                fit style="width: 100%;" @row-click="rowClick">
                <el-table-column v-for="(sub, index) in subNoCreateTs" :key="index" :prop="sub.ticket_fields"
                  :class-name="sub.ticket_fields" :label="sub.list_fields" align="center">
                  <template slot-scope="scope">
                    <span v-if="sub.ticket_fields == 'created_at'">{{ convertedTime(scope.row[sub.ticket_fields])
                    }}</span>
                    <span v-else :class="getCellClass(sub.ticket_fields, scope.row)">{{ scope.row[sub.ticket_fields]
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-skeleton>
          <!-- <el-pagination background layout="prev, pager, next" @current-change="changePage(item)" :page-size="1"
            :total="this.$store.state.udeskListCount">
          </el-pagination> -->
          <div class="pagin" v-if="!loading && $store.state.udeskList.length != 0">


            <ul class="pagination">
              <li><a class="img right" @click="toStart()"><img src="../assets/images/arrow.svg" alt=""
                    class="arrow-turn"><img src="../assets/images/arrow.svg" alt="" class="arrow-turn"></a></li>
              <li v-for="item in this.$store.state.udeskListCount" :key="item"><a @click="changePage(item)" class="num"
                  :class="activePage == '#' + item ? 'active' : ''" :href="'#' + item">{{
                    item
                  }}</a></li>
              <li><a class="img le" href="#"><img src="../assets/images/arrow.svg" alt="" class="arrow"></a></li>
              <li><a class="img left" @click="toEnd()"><img src="../assets/images/arrow.svg" alt="" class="arrow"><img
                    src="../assets/images/arrow.svg" alt="" class="arrow"></a></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone';
import BannerSearch from "../components/BannerSearch.vue";
import MyShowList from "../components/MyShowList.vue";
import i18n from "../lang";

export default {
  components: { BannerSearch, MyShowList },
  // inject: ['loading', 'stopLoading'],
  data() {
    return {
      num: 1,
      li: ["Any", "Solving", "Reply Recelved", "Solved"],
      activePage: '',
      search: "",
      loadingId: [],
      loading: true,
      options: [{ label: '全部', value: '' }, { label: '待解决', value: '1' }, { label: '解决中', value: '4' }, { label: '已解决', value: '2' }, { label: '已关闭', value: '3' }],
      optionsEn: [{ label: 'Any', value: '' }, { label: 'Open', value: '1' }, { label: 'In progress', value: '4' }, { label: 'Solved', value: '2' }, { label: 'Closed', value: '3' }],
      searchStatus: '',
      count: 0,
      subNoCreateTs: [],
      userTimeZone: "",
    };
  },
  computed: {
    // 创建计算属性来过滤和转换数据
    filteredUdeskList() {
      const search = this.$store.state.search; // 假设您的搜索条件存储在 Vuex 中的 search 状态中
      const udeskList = this.$store.state.udeskList;

      if (search) {
        return udeskList.filter(data =>
          data.TextField_2078.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        return udeskList;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.activePage = this.$route.hash
    },
    searchStatus(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal)
      // this.$udesk.sdk
      //   .request()
      //   .getTicketList({page: '1', status_id: val })
      //   .then((res) => {
      //     console.log("工单列表", res);
      //     this.$store.commit("SaveUdeskList", res)
      //     this.loading = false
      //   });
      this.toStart()
    },
  },
  mounted() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.activePage = this.$route.hash
    this.changePage(this.activePage.replace("#", ''))
    var count = 0
    let timer = setInterval(() => {
      count++
      if (count >= 50) {
        clearInterval(timer)
      }
      if (this.$store.state.udeskSub != []) {
        clearInterval(timer)
        this.$store.state.udeskSub.map(res => {
          if (res.ticket_fields != "created_at") {
            this.subNoCreateTs.push(res)
          }

        })
      }

    }, 200);
  },
  methods: {
    hooseCustomZH() {
      //调用element-ui select组件blur方法
      //要包再timeout里面，直接调用不会关闭下拉框option
      setTimeout(() => {
        this.$refs.multiSelectZH.blur()
      }, 50)
    },
    hooseCustomEN() {
      //调用element-ui select组件blur方法
      //要包再timeout里面，直接调用不会关闭下拉框option
      setTimeout(() => {
        this.$refs.multiSelectEN.blur()
      }, 50)
    },
    getCellClass(fieldName, row) {

      if (this.$i18n.locale == 'zh') {
        // 根据单元格内容和字段名返回不同的 CSS 类
        if (row[fieldName] === '开启') {
          row[fieldName] = '待解决';
        } else if (row[fieldName] === '解决中') {
          return 'solve-cell';
        } else if (row[fieldName] === '待解决') {
          return 'open-cell';
        } else if (row[fieldName] === '已解决') {
          return 'finish-cell';
        } else if (row[fieldName] === '已关闭') {
          return 'closed-cell'
        } else {
          return 'cell';
        }
      } else {
        // 根据单元格内容和字段名返回不同的 CSS 类
        if (row[fieldName] === '开启') {
          row[fieldName] = 'Open';
        } else if (row[fieldName] === 'Solving') {
          row[fieldName] = 'In progress'
        } else if (row[fieldName] === 'In progress') {
          return 'solve-cell';
        } else if (row[fieldName] === 'Open') {
          return 'open-cell';
        } else if (row[fieldName] === 'Resolved') {
          row[fieldName] = 'Solved';
        } else if (row[fieldName] === 'Solved') {
          return 'finish-cell';
        } else if (row[fieldName] === 'Closed') {
          return 'closed-cell'
        } else {
          return 'cell';
        }
      }



    },

    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    toStart() {
      var a = document.createElement('a');
      a.setAttribute('href', '#1');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a)
      this.changePage('1')
    },
    toEnd() {
      var a = document.createElement('a');
      a.setAttribute('href', '#' + this.$store.state.udeskListCount);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a)
      this.changePage(this.$store.state.udeskListCount)
    },
    changePage(item) {
      let langs =
        localStorage.getItem("preferredLang") == "zh" ? "" : "en-us";
      this.loading = true
      var countr = 0
      let timer = setInterval(() => {
        countr++
        if (countr >= 50) {
          clearInterval(timer)
        }
        if (this.$udesk.isReady == true) {
          if (localStorage.getItem('result_code') == '') {

            clearInterval(timer)
            this.$store.commit("Logout");
            this.$router.push('/login')
          }
          console.log(localStorage.getItem('result_code'));
          this.$udesk.sdk
            .request()
            .getTicketList({ url_lang: langs, page: item, status_id: this.searchStatus ? this.searchStatus : '',desc:'测试工单1' })
            .then((res) => {
              console.log("工单列表", res);

              this.loading = false
              res.tickets.map(item => {
                if (!item.TextField_1815) {
                  this.loading = true
                  this.count++
                  this.$axios({
                    method: 'post',
                    url: this.$backend.host,
                    headers: {
                      jwt: localStorage.getItem('result_code'),
                      'x-source': 'Nemo'
                    },
                    data: {
                      'Query': 'mutation { addHashIdToTicket ( ticketId: "' + item.id + '"){hashId} }'
                    }
                  }).then(results => {
                    console.log(results);
                    item.TextField_1815 = results.data.result.addHashIdToTicket.hashId
                    this.count--
                  })
                }
              })
              this.$store.commit("SaveUdeskList", res)

            }).catch(err => {
              console.log(err);
              clearInterval(timer)
              this.$store.commit("Logout");
              this.$router.push('/login')
            })
          var count2 = 0
          let timer2 = setInterval(() => {
            count2++
            if (count2 >= 50) {
              clearInterval(timer2)
            }
            if (this.count == 0) {
              this.loading = false
              clearInterval(timer2)
            }

          }, 500);
          clearInterval(timer)
        }
      }, 500);


    },
    padZero(number) {
      return number.toString().padStart(2, "0");
    },
    convertedTime(time) {
      // 将原始时间转换为用户所在时区的时间
      const beijingTime = new Date(time);
      const year = beijingTime.getFullYear();
      const month = beijingTime.getMonth() + 1;
      const day = beijingTime.getDate();
      const hours = beijingTime.getHours();
      const minutes = beijingTime.getMinutes();
      const seconds = beijingTime.getSeconds();
      const formattedTime = `${year}-${this.padZero(month)}-${this.padZero(day)}T${this.padZero(hours)}:${this.padZero(
        minutes
      )}:${this.padZero(seconds)}.000+08:00`;

      const converted = moment(formattedTime).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      console.log(converted.format('YYYY-MM-DD HH:mm:ss'));
      return converted.format('YYYY-MM-DD HH:mm:ss');
    },
    rowClick(row, column, cell, event) {
      console.log(row)
      this.$router.push('/tickets/my-tickets/' + row.id)

    },
    // getUdeskList(num) {
    //   this.loading = true
    //   console.log(this.searchStatus);
    //   this.$udesk.sdk
    //     .request()
    //     .getTicketList({ page: num, status_id: this.searchStatus ? this.searchStatus : '' })
    //     .then((res) => {
    //       console.log("工单列表", res);
    //       this.$store.commit("SaveUdeskList", res.tickets);
    //       this.loading = false
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
.open-cell {
  color: #ea6c2e;
}

.solve-cell {
  color: #4892ed;
}

.finish-cell {
  color: #3ab245;
}

.closed-cell {
  color: #909399;
}

@import "../assets/scss/myticket.scss";
</style>